import { Tag, Typography } from '@monorepo/nova-ui';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

interface StyledMainTypographyProps {
  isExceeded?: boolean;
}

/**
 * Styled Typography component for main text
 * Applies theme.palette.text.main color, or error color when exceeded
 */
export const StyledMainTypography = styled(
  Typography,
)<StyledMainTypographyProps>(({ theme, isExceeded }) => ({
  color: isExceeded ? theme.palette.error.main : theme.palette.text.main,
}));

/**
 * Styled Typography component for secondary text
 * Applies theme.palette.text.second color
 */
export const StyledSecondaryTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.second,
}));

interface StyledCapTagProps {
  isExceeded?: boolean;
}

/**
 * Styled Tag component for cap limit badge
 * Applies yellow background with 10% opacity and yellow border when within limit
 * Applies error colors when exceeded
 */
export const StyledCapTag = styled(Tag)<StyledCapTagProps>(
  ({ theme, isExceeded }) => ({
    display: 'flex',
    height: '32px',
    padding: '0 8px',
    alignItems: 'center',
    gap: '6px',
    marginTop: theme.spacing(3),
    backgroundColor: isExceeded
      ? alpha(theme.palette.error.main, 0.1)
      : alpha(theme.palette.yellow.main, 0.1),
    borderColor: isExceeded
      ? theme.palette.error.main
      : theme.palette.yellow.main,
    borderWidth: 1,
    borderStyle: 'solid',
  }),
);
